import '@jgp-er-dev/charts/dist/index.css'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import '@fontsource/work-sans/300.css'
import '@fontsource/work-sans/400.css'
import '@fontsource/work-sans/500.css'
import '@fontsource/work-sans/600.css'
import '@fontsource/work-sans/700.css'
import './index.css'
import './index.scss'

import Highcharts from 'highcharts'
import React from 'react'
// `@types/react-dom` no projeto ainda está em v17 (não expõe o subpath
// /client), mas o runtime instalado é v18 — bumpar os types cascatearia
// em outros lugares. Suprimimos o erro aqui em vez de subir a versão.
// @ts-expect-error react-dom@18 runtime / @types/react-dom@17 mismatch
import { createRoot } from 'react-dom/client'

import App from './App'
import { patchHighchartsExports } from './utils/highchartsCsv'
// import reportWebVitals from './reportWebVitals'

// Silencia o aviso "Consider including the accessibility.js module". Não
// usamos screen readers nos dashboards internos; se um dia precisar, basta
// importar 'highcharts/modules/accessibility' aqui e remover esta linha.
Highcharts.setOptions({ accessibility: { enabled: false } })
// Download CSV/XLS de TODOS os gráficos com decimal PONTO + data dd/mm/aaaa
// (regra da mesa) — aplica nas duas instâncias do Highcharts do bundle.
patchHighchartsExports(Highcharts)

const container = document.getElementById('root')
if (!container) throw new Error('Root container not found')
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
